package com.devi3east.bashbuddy.account.organization.responses

import com.devi3east.bashbuddy.account.organization.domain.models.Organization
import kotlinx.serialization.Serializable

@Serializable
data class UpdateOrganizationResponse(
    val modified: Boolean,
    val organization: Organization?
)